module.exports = __webpack_public_path__ + "static/img/new_about3.8884919.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images_new/new_about3.png
// module id = ghZb
// module chunks = 1